export const errosInstitution: {
    [index: string]: {
        title: string
        description?: string
    }
} = {
    '2001': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2002': {
        title: 'Algo deu errado.',
        description: 'Tente novamente em alguns minutos.'
    },
    '2005': {
        title: 'Vinculado cadastrado anteriormente.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2008': {
        title: 'Instituição inexistente.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2009': {
        title: 'Agente financeiro inexistente.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2010': {
        title: 'Vinculo inexistente.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2012': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique o CPF e tente novamente.'
    },
    '2013': {
        title: 'CPF cadastrado anteriormente.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2014': {
        title: 'Tipo de perfil inexistente.',
        description: 'Verifique os dados e tente novamente.'
    },
    '2015': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique o e-mail e tente novamente.'
    },
    '2016': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique o contato e tente novamente.'
    },
    '2017': {
        title: 'E-mail cadastrado anteriormente.',
        description: 'Verifique os dados e tente novamente.'
    }
}
